export default __webpack_public_path__ + "static/media/spinner.60553041.gif";